export const BIKE_HISTORY_LOADING = "BIKE_HISTORY_LOADING";
export const BIKE_HISTORY_ERROR = "BIKE_HISTORY_ERROR";
export const BIKE_HISTORY_LIST = "BIKE_HISTORY_LIST";
export const BIKE_HISTORY_FILTERS = "BIKE_HISTORY_FILTERS";



// WEBPACK FOOTER //
// ./src/actions/bike-history/constants.js